<template>
	<div onresize="detect" class="PaymentBannerContainer container-fluid px-0 mx-0">
		<div class="Row">
			<div class="PaymentBannerBanks">
				<div class="PaymentBannerDiv d-flex">
					<img class="PaymentLogo" :src="applepay" alt="applepay">
					<img class="PaymentLogo" :src="googlepay" alt="googlepay">
					<img class="PaymentLogo" :src="visa" alt="visa">
					<img class="PaymentLogo" :src="mastercard" alt="mastercard" />
					<img class="PaymentLogo" :src="amex" alt="amex" />
					<img class="PaymentLogo" :src="paypal" alt="paypal" />
					<div class="d-flex flex-wrap" style="width: 15px;">
						<img :src="carnet" class="PaymentLogoDual" alt="carnet" style="width: 100%;" />	
						<img :src="barril" class="PaymentLogoDual" alt="pay" style="width: 100%;" />
					</div>
					<div class="d-flex flex-wrap" style="width: 15px;">
						<img :src="clickpay" class="PaymentLogoDual" alt="clickpay" style="width: 100%;" />
						<img :src="discover" class="PaymentLogoDual" alt="discover" style="width: 100%;" />
					</div>
					<img class="PaymentLogo" :src="reserva" alt="reserva" />
					<img class="PaymentLogo" :src="oxxo" alt="oxxo" />
					<img class="PaymentLogo" :src="farmaciasdelahorro" alt="farmaciasdelahorro" />
					<img class="PaymentLogo" :src="walmart" alt="walmart" />
				</div>
			</div>	
			<div class="PaymentBannerService">	
				<div class="PaymentBannerDiv d-flex">
					<img class="PaymentLogo" :src="months" alt="12meses" />
					<img class="PaymentLogo" :src="banamex" alt="banamex" />
					<img class="PaymentLogo" :src="bbva" alt="bbva" />
					<img class="PaymentLogo" :src="santander" alt="santander" />
					<img class="PaymentLogo" :src="hsbc" alt="hsbc" />
					<div class="d-flex flex-wrap ContainerDual">
						<img :src="scotiabank" alt="scotiabank" class="PaymentLogoDual" style="width: 100%;"/>
						<img :src="banorte" alt="banorte" class="PaymentLogoDual" style="width: 100%;"/>
					</div>
					<div class="d-flex flex-wrap ContainerDual">
						<img :src="banregio" alt="banregio" class="PaymentLogoDual" style=" width: 100%;"/>
						<img :src="inbursa" alt="inbursa" class="PaymentLogoDual" style="width: 100%;"/>
					</div>
					<div class="d-flex flex-wrap ContainerDual">
						<div style="width: 100%;">
							<div class="d-flex no-wrap" style="width: 100%;">
								<img :src="liverpool" class="PaymentLogoDualOne" alt="liverpool" style="width: 100%;"/>
							</div>
							<div class="d-flex no-wrap" style="width: 100%;">
								<img :src="invex" class="PaymentLogoDual" alt="invex" style="width: 50%;"/>
								<img :src="bancoazteza" class="PaymentLogoDual" alt="bancoazteza" style="width: 50%;"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// IMG
	import visa from '@@/images/icons_payments/visa.svg'	
	import mastercard from '@@/images/icons_payments/mastercard.svg'
	import applepay from '@@/images/icons_payments/applepay.svg'
	import googlepay from '@@/images/icons_payments/googlepay.svg'
	import amex from '@@/images/icons_payments/amex.svg'
	import paypal from '@@/images/icons_payments/paypal.svg'
	import barril from '@@/images/icons_payments/barril.svg'
	import carnet from '@@/images/icons_payments/carnet.svg'
	import clickpay from '@@/images/icons_payments/clickpay.svg'
	import discover from '@@/images/icons_payments/discover.svg'
	import reserva from '@@/images/icons_payments/reserva.svg'
	import months from '@@/images/icons_payments/12meses.svg'
	import oxxo from '@@/images/icons_payments/oxxo.svg'
	import farmaciasdelahorro from '@@/images/icons_payments/farmaciasdelahorro.svg'
	import walmart from '@@/images/icons_payments/walmart.svg'
	import bbva from '@@/images/icons_payments/bbva.svg'
	import banamex from '@@/images/icons_payments/banamex.svg'
	import santander from '@@/images/icons_payments/santander.svg'
	import scotiabank from '@@/images/icons_payments/scotiabank.svg'
	import banorte from '@@/images/icons_payments/banorte.svg'
	import hsbc from '@@/images/icons_payments/hsbc.svg'
	import banregio from '@@/images/icons_payments/banregio.svg'
	import inbursa from '@@/images/icons_payments/inbursa.svg'
	import invex from '@@/images/icons_payments/invex.svg'
	import bankbajio from '@@/images/icons_payments/bankbajio.svg'
	import liverpool from '@@/images/icons_payments/liverpool.svg'
	import bancoazteza from '@@/images/icons_payments/bancoazteca.svg'
	export default{
		data(){
			return{
				dimensions:{
					width:0,
					height:0
				},
				// IMG
				visa: visa,
				mastercard: mastercard,
				applepay: applepay,
				amex: amex,
				paypal: paypal,
				barril: barril,
				carnet: carnet,
				clickpay: clickpay,
				discover: discover,
				reserva: reserva,
				months: months,
				oxxo: oxxo,
				farmaciasdelahorro: farmaciasdelahorro,
				walmart: walmart,
				santander: santander,
				scotiabank: scotiabank,
				banorte: banorte,
				hsbc: hsbc,
				banregio: banregio,
				inbursa: inbursa,
				banamex: banamex,
				invex: invex,
				bbva: bbva,
				bankbajio: bankbajio,
				liverpool: liverpool,
				bancoazteza: bancoazteza,
				googlepay: googlepay
			}
		},
		methods:{
			detect(){
				this.dimensions.width = window.innerWidth
				this.dimensions.height = window.innerHeight
			}
		},
		beforeMount(){
			this.detect()
		}
	}
</script>

<style lang='scss'>
@media only screen and (max-width:450px){
	.PaymentBannerContainer{
		background-color: #000;
	    width: 100%;
	    color: #fff;
	}
	.Row{
		display:flex;
		flex-direction:column;
		height:20px;
		justify-content:center;
		background-color:black;
		.PaymentBannerDiv{
			text-align:center;
		}
		.PaymentLogo{
			height:10px;
		}
		.PaymentLogoDual{
			height:7px;
		}
		.PaymentLogoDualOne{
			height: 7px;	
		}
		.ContainerDual{
			width: 35px;
		}
		.ContainerSimple{
			width: 15px;
		}
		span{
			padding:0px 5px 0px 5px;
			font-size:7px;
		}
	}
}
@media only screen and (max-width:499px){
	.PaymentBannerContainer{
		background-color: #000;
	    width: 100%;
	    color: #fff;
	    margin: 5px;
	}
	.Row{
		display:flex;
		flex-direction:column;
		align-items:center;
		height:25px;
		justify-content:center;
		background-color:black;
		.PaymentBannerDiv{
			text-align:center;
		}
		.PaymentLogo{
			height:11px;
			padding: 1px;
		}
		.PaymentLogoDual{
			height:7px;
		}
		.PaymentLogoDualOne{
			height: 7px;	
		}
		.ContainerDual{
			width: 35px;
		}
		.ContainerSimple{
			width: 15px;
		}
		span{
			padding:0px 5px 0px 5px;
			font-size:7px;
		}
	}
}
@media only screen  and (min-width:500px) and (max-width: 699px){
	.PaymentBannerContainer{
		background-color: #000;
	    width: 100%;
	    margin: 5px;
	    color: #fff;
	}
	.Row{
		display:flex;
		flex-direction:column;
		align-items:center;
		height:45px;
		justify-content:center;
		background-color:black;
		.PaymentBannerDiv{
			text-align:center;
		}
		.PaymentLogo{
			height:17px;
		}
		.PaymentLogoDual{
			height:10px;
		}
		.PaymentLogoDualOne{
			height: 12px;	
		}
		.ContainerDual{
			width: 50px;
		}
		.ContainerSimple{
			width: 15px;
		}
		.PaymentBannerBanks{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
		}
		.PaymentBannerService{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
		}
		span{
			padding:0px 5px 0px 5px;
			font-size:7px;
		}
	}
}
@media only screen and (min-width: 700px) and (max-width:1064px){
	.PaymentBannerContainer{
		background-color: #000;
	    width: 100%;
	    margin: 10px;
	    color: #fff;
	}
	.Row{
		display:flex;
		flex-direction:column;
		align-items:center;
		height:45px;
		background-color:black;
		.PaymentBannerDiv{
			text-align:center;
		}
		.PaymentBannerBanks{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
			text-align:center;
		}
		.PaymentBannerService{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
			text-align:center;
		}
		.PaymentLogo{
			height:20px;
		}
		.PaymentLogoDual{
			height:12px;
		}
		.PaymentLogoDualOne{
			height: 15px;	
		}
		.ContainerDual{
			width: 60px;
		}
		.ContainerSimple{
			width: 15px;
		}
		span{
			padding:0px 5px 0px 5px;
			font-size:14px;
		}
	}
}
@media only screen and (min-width: 1065px){
	.PaymentBannerContainer{
		background-color: #000;
	    width: 100%;
	    height:30px;
	    margin-top: 4px;
	    margin-botton: 4px;
	    color: #fff;
	}
	.Row{
		display:flex;
		flex-direction:row;
		align-items:center;
		height:32px;
		justify-content:center;
		background-color:black;
		.PaymentBannerDiv{
			text-align:center;
			align-items: center;
		}
		.PaymentLogo{
			height:21px;
		}
		.PaymentLogoDual{
			height:14px;
		}
		.PaymentLogoDualOne{
			height: 16px;	
		}
		.ContainerDual{
			width: 80px;
		}
		.ContainerSimple{
			width: 20px;
		}
		.PaymentBannerBanks{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
		}
		.PaymentBannerService{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
		}
		span{
			padding:0px 5px 0px 5px;
			font-size:14px;
		}
	}
}
@media only screen and (min-width: 1280px) and (max-width:1064px){
	.PaymentBannerContainer{
		background-color: #000;
	    width: 100%;
	    height:30px;
	    margin-top: 4px;
	    margin-botton: 4px;
	    color: #fff;
	}
	.Row{
		display:flex;
		flex-direction:row;
		align-items:center;
		height:50px;
		justify-content:center;
		background-color:black;
		.PaymentBannerDiv{
			text-align:center;
			align-items: center;
		}
		.PaymentLogo{
			height:18px;
		}
		.PaymentLogoDual{
			height:12px;
		}
		.PaymentLogoDualOne{
			height: 14px;	
		}
		.ContainerDual{
			width: 60px;
		}
		.ContainerSimple{
			width: 15px;
		}
		.PaymentBannerBanks{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
		}
		.PaymentBannerService{
			display:flex;
			flex-direction:row;
			align-items:center;
			justify-content:space-around;
		}
		span{
			padding:0px 5px 0px 5px;
			font-size:14px;
		}
	}
}
</style>